import * as z from "zod";

export const getProductSkus = {
  name: "getProductSkus" as const,
  input: z.object({ search: z.string().optional() }),
  output: z.object({
    products: z.array(
      z.object({ sku: z.string(), title: z.string().nullable() }),
    ),
  }),
};
